/* Widget overrides for `Kommunicate.customizeWidgetCss` (bundled via ?inline for embeds). */

:root {
  --fintepla-purple: #68308e;
  --fintepla-purple-hover: #5a277b;
  --fintepla-focus-ring: rgba(104, 48, 142, 0.3);
  /* drop-shadow follows the avatar alpha; softer than box-shadow on a square box. */
  --fintepla-launcher-shadow-filter: drop-shadow(0 2px 4px rgba(55, 36, 78, 0.14))
    drop-shadow(0 8px 20px rgba(55, 36, 78, 0.1));
  --fintepla-font-heading: 'Tisa Sans Pro', Inter, ui-sans-serif, system-ui,
    -apple-system, 'Segoe UI', Roboto, Helvetica, Arial;
  --fintepla-font-body: Inter, ui-sans-serif, system-ui, -apple-system,
    'Segoe UI', Roboto, Helvetica, Arial;
}

/* `!important` kept where Kommunicate uses inline styles at runtime. */

#mck-sidebox {
  border-radius: 8px !important;
  overflow: hidden !important;
}

#mck-sidebox #mck-sidebox-content {
  overflow: visible !important;
}

#mck-sidebox .mck-box-top,
#mck-sidebox div.mck-box-top {
  background: var(--fintepla-purple) !important;
  color: #ffffff !important;
  box-sizing: border-box !important;
  height: 61px !important;
  min-height: 61px !important;
  max-height: 61px !important;
  padding-top: 12px !important;
  padding-bottom: 12px !important;
  border: 0 !important;
  box-shadow: none !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  -webkit-backdrop-filter: blur(25px) !important;
  backdrop-filter: blur(25px) !important;
  position: relative !important;
  overflow: visible !important;
  z-index: 1002 !important;
}

#mck-sidebox .mck-box-top .mck-name-status-container,
#mck-sidebox .mck-box-top .mck-name-status-container.mck-truncate {
  overflow: visible !important;
}

#mck-sidebox .mck-box-top .mck-agent-image-container {
  width: 70px !important;
  height: 70px !important;
  flex: 0 0 auto !important;
  margin-left: 15px !important;
  transform: translate(-5px, 8px) !important;
  transform-origin: top left !important;
  position: relative !important;
  z-index: 1003 !important;
}

#mck-sidebox .mck-box-top .mck-agent-image {
  width: 70px !important;
  height: 70px !important;
  border-radius: 50% !important;
  object-fit: cover !important;
  background-color: transparent !important;
}

#mck-sidebox .mck-box-top #mck-agent-status-text,
#mck-sidebox .mck-box-top .mck-typing-box,
#mck-sidebox .mck-box-top .mck-agent-status-indicator {
  display: none !important;
}

/* Header overflow (⋯) menu — not needed for this deployment. */
#mck-sidebox #km-widget-options {
  display: none !important;
}

#mck-sidebox .mck-box-top *,
#mck-sidebox .mck-box-top #mck-tab-title,
#mck-sidebox .mck-box-top #mck-conversation-title {
  font-family: var(--fintepla-font-heading) !important;
  color: #ffffff !important;
}

#mck-sidebox .mck-box-top #mck-tab-title,
#mck-sidebox .mck-box-top #mck-conversation-title {
  font-size: 18px !important;
  line-height: 20px !important;
  font-weight: 400 !important;
  letter-spacing: 0.16px !important;
  text-align: left !important;
}

#mck-sidebox .mck-box-top #mck-tab-title {
  display: block !important;
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto,
    Helvetica, Arial !important;
  max-width: 16ch !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  transform: translateY(14px) !important;
}

#mck-sidebox #mck-box-form-container #mck-msg-form,
#mck-sidebox #mck-box-form-container .mck-msg-form,
#mck-sidebox #mck-box-form-container > .mck-box-form.mck-row {
  display: none !important;
  height: 0 !important;
  min-height: 0 !important;
  max-height: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  border: 0 !important;
  overflow: hidden !important;
}

/* Zero #mck-sidebox-ft side padding; purple wrapper covers transition flicker. */
#mck-sidebox #mck-sidebox-ft {
  padding: 0 !important;
  background: var(--fintepla-purple) !important;
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  overflow: hidden !important;
}

#mck-sidebox #mck-box-form-container {
  display: block !important;
  padding: 0 !important;
  margin: 0 !important;
  border: 0 !important;
  height: 50px !important;
  min-height: 50px !important;
  max-height: 50px !important;
  width: 100% !important;
  background: var(--fintepla-purple) !important;
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  overflow: hidden !important;
}

/* Hide preview chip + badge so the dashboard greeting is the only teaser. */
#mck-msg-preview-visual-indicator,
.mck-msg-preview-visual-indicator-container,
.mck-msg-preview,
#applozic-badge-count,
.applozic-badge-count {
  display: none !important;
  pointer-events: none !important;
}

/* Built-in Kommunicate greeting popup bubble (dashboard feature). */
#chat-popup-widget-container {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  overflow: visible !important;
  z-index: 2147483646 !important;
  top: auto !important;
  left: auto !important;
  bottom: 10px !important;
  right: 80px !important;
  height: auto !important;
  width: auto !important;
  max-width: none !important;
  transform: translateY(20px) !important;
}

#chat-popup-widget-container .chat-popup-widget-text-wrapper {
  padding: 6px 0 0 !important;
  margin: 0 !important;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  overflow: visible !important;
  display: block !important;
}

#chat-popup-widget-container .fintepla-greeting-bubble {
  position: relative !important;
  display: inline-block !important;
  line-height: 0 !important;
  cursor: pointer !important;
  padding-top: 16px !important;
}

#chat-popup-widget-container .fintepla-greeting-bubble__img {
  display: block !important;
  width: 240px !important;
  height: auto !important;
}

#chat-popup-widget-container .fintepla-greeting-bubble__close {
  position: absolute !important;
  top: 17px !important;
  right: 27px !important;
  width: 22px !important;
  height: 22px !important;
  border: 0 !important;
  background: transparent !important;
  padding: 0 !important;
  margin: 0 !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

#chat-popup-widget-container .fintepla-greeting-bubble__close img {
  display: block !important;
  width: 22px !important;
  height: 22px !important;
}

/* Launcher: no circular plate — SDK still paints borders / native button chrome as a square. */
#mck-sidebox-launcher {
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  border: 0 !important;
  outline: none !important;
  padding: 0 !important;
  overflow: visible !important;
  -webkit-appearance: none !important;
  appearance: none !important;
}

#mck-sidebox-launcher:focus-visible {
  outline: 2px solid var(--fintepla-focus-ring) !important;
  outline-offset: 2px !important;
}

#mck-sidebox-launcher::-moz-focus-inner {
  border: 0 !important;
  padding: 0 !important;
}

/* Launcher: SDK retargets <img> src; use `var(--fintepla-chatbot-avatar)` from widget-css.js. */
#mck-sidebox-launcher #launcher-svg-container,
#mck-sidebox-launcher #launcher-agent-img-container {
  border-radius: 0 !important;
  border: 0 !important;
  outline: none !important;
  box-shadow: none !important;
  overflow: visible !important;
  -webkit-filter: var(--fintepla-launcher-shadow-filter) !important;
  filter: var(--fintepla-launcher-shadow-filter) !important;
  background-image: var(--fintepla-chatbot-avatar) !important;
  background-size: contain !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  background-color: transparent !important;
}

/* Hide duplicate <img>; visibility avoids a brief broken-image/outline square on load. */
#mck-sidebox-launcher #launcher-svg-container img,
#mck-sidebox-launcher #launcher-agent-img-container img {
  visibility: hidden !important;
}

#mck-sidebox .fintepla-speak-to-person {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-sizing: border-box !important;
  width: 100% !important;
  height: 50px !important;
  min-height: 50px !important;
  max-height: 50px !important;
  padding: 0 16px !important;
  margin: 0 !important;
  background: var(--fintepla-purple) !important;
  color: #ffffff !important;
  font-family: var(--fintepla-font-body) !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 1 !important;
  text-align: center !important;
  border: 0 !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  cursor: pointer !important;
  box-shadow: none !important;
  outline: none !important;
  -webkit-appearance: none !important;
  appearance: none !important;
  transition: background-color 0.15s ease !important;
}

#mck-sidebox .fintepla-speak-to-person:hover {
  background: var(--fintepla-purple-hover) !important;
}

#mck-sidebox .fintepla-speak-to-person:focus-visible {
  outline: 2px solid var(--fintepla-focus-ring) !important;
  outline-offset: 2px !important;
}

#mck-sidebox .fintepla-speak-to-person[aria-busy='true'] {
  opacity: 0.6 !important;
  cursor: progress !important;
}

/* PDF link strip: injected after .mck-box-top; selector drift → src/config.js SELECTORS. */
#mck-sidebox #fintepla-resource-strip.fintepla-resource-strip {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
  box-sizing: border-box !important;
  width: 100% !important;
  height: 50px !important;
  min-height: 50px !important;
  max-height: 50px !important;
  padding: 0 20px !important;
  margin: 0 !important;
  background: rgba(255, 255, 255, 0.75) !important;
  border: 0 !important;
  /* 3px bar under the row without eating border-box height (vs border). */
  box-shadow: 0 3px 0 0 var(--fintepla-purple) !important;
  position: relative !important;
  z-index: 1001 !important;
}

#mck-sidebox #fintepla-resource-strip .fintepla-resource-strip__col {
  flex: 1 1 0 !important;
  min-width: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
}

#mck-sidebox #fintepla-resource-strip .fintepla-resource-strip__inner {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

#mck-sidebox #fintepla-resource-strip .fintepla-resource-strip__inner--left {
  padding-right: 13px !important;
}

#mck-sidebox #fintepla-resource-strip .fintepla-resource-strip__inner--right {
  padding-left: 13px !important;
}

#mck-sidebox #fintepla-resource-strip .fintepla-resource-strip__divider {
  display: block !important;
  width: 1px !important;
  height: 32px !important;
  background: var(--fintepla-purple) !important;
  margin: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  flex-shrink: 0 !important;
  align-self: center !important;
}

#mck-sidebox #fintepla-resource-strip .fintepla-resource-strip__link {
  display: inline-block !important;
  font-family: 'Tisa Sans Pro', sans-serif, Georgia, serif !important;
  font-size: 15px !important;
  font-weight: 400 !important;
  line-height: 1.2 !important;
  color: var(--fintepla-purple) !important;
  text-decoration: underline !important;
  text-decoration-color: var(--fintepla-purple) !important;
  text-underline-offset: 2px !important;
  white-space: nowrap !important;
  background: transparent !important;
  border-radius: 2px !important;
  outline: none !important;
  transition: opacity 0.1s ease !important;
}

#mck-sidebox #fintepla-resource-strip .fintepla-resource-strip__link:hover {
  text-decoration: underline !important;
  color: var(--fintepla-purple) !important;
}

#mck-sidebox #fintepla-resource-strip .fintepla-resource-strip__link:focus-visible {
  outline: 2px solid var(--fintepla-purple) !important;
  outline-offset: 2px !important;
}

#mck-sidebox #fintepla-resource-strip .fintepla-resource-strip__link:active {
  opacity: 0.8 !important;
}

/* Transcript: message list, bubbles, quick replies. */

#mck-sidebox #mck-message-cell .mck-message-inner {
  padding: 16px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  overscroll-behavior: contain !important;
}

#mck-sidebox #mck-message-cell .mck-message-inner .mck-m-b {
  position: relative !important;
  outline: none !important;
}

#mck-sidebox #mck-message-cell .mck-message-inner .mck-m-b.mck-msg-right {
  margin-bottom: 3px !important;
}

#mck-sidebox #mck-message-cell .mck-msg-left-muted,
#mck-sidebox #mck-message-cell .mck-msg-right-muted,
#mck-sidebox #mck-message-cell .mck-msg-center-muted {
  display: none !important;
}

#mck-sidebox #mck-message-cell .mck-msg-feedback-sticker,
#mck-sidebox #mck-message-cell .mck-message-status.mck-read-icon,
#mck-sidebox #mck-message-cell .mck-message-status.mck-delivered-icon {
  display: none !important;
}

/* Hide the conversation-name line above bubbles (we control avatars separately). */
#mck-sidebox #mck-message-cell .mck-conversation-name {
  display: none !important;
}

/* Layout: avatar col + bubble col aligned at bottom. */
#mck-sidebox #mck-message-cell .mck-message-inner .mck-m-b .mck-clear .blk-lg-12 {
  display: flex !important;
  align-items: flex-end !important;
}

#mck-sidebox #mck-message-cell .mck-message-inner .mck-msg-avator.blk-lg-3 {
  flex: 0 0 36px !important;
  width: 36px !important;
  height: 36px !important;
  margin-right: 12px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50% !important;
}

/* Avatar image should only show next to quick replies, until a selection occurs. */
#mck-sidebox
  #mck-message-cell
  .mck-message-inner
  .contains-quick-replies-only
  .mck-msg-avator.blk-lg-3 {
  background-image: var(--fintepla-chatbot-avatar) !important;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
}

#mck-sidebox #mck-message-cell .mck-message-inner .mck-msg-avator.blk-lg-3 img {
  width: 36px !important;
  height: 36px !important;
  border-radius: 50% !important;
  object-fit: cover !important;
  display: block !important;
  opacity: 0 !important;
}

/* After a quick-reply selection, hide the transcript avatar entirely. */
#mck-sidebox[data-fintepla-quick-reply-selected='true']
  #mck-message-cell
  .mck-message-inner
  .mck-msg-avator.blk-lg-3 {
  background-image: none !important;
}

#mck-sidebox #mck-message-cell .mck-message-inner .km-conversation-container-right {
  flex: 1 1 auto !important;
  min-width: 0 !important;
}

/* Shared bubble typography + spacing */
#mck-sidebox #mck-message-cell .mck-message-inner .mck-msg-box {
  padding: 8px 16px !important;
  border-radius: 8px !important;
  white-space: pre-wrap !important;
  overflow-wrap: break-word !important;
  font-family: 'Tisa Sans Pro', Inter, system-ui, sans-serif !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  font-weight: 400 !important;
}

/* Bot bubbles (received) */
#mck-sidebox #mck-message-cell .mck-message-inner .mck-msg-left .mck-msg-box,
#mck-sidebox #mck-message-cell .mck-message-inner .mck-msg-center .mck-msg-box {
  background: #f0f0f0 !important;
  color: #231f20 !important;
  border: 0.5px solid rgba(0, 0, 0, 0.08) !important;
}

/* User bubbles (sent) */
#mck-sidebox #mck-message-cell .mck-message-inner .mck-msg-right .mck-msg-box,
#mck-sidebox #mck-message-cell .mck-message-inner .mck-msg-right .mck-msg-box * {
  background: var(--fintepla-purple) !important;
  color: #ffffff !important;
  border: 0 !important;
}

#mck-sidebox #mck-message-cell .mck-message-inner .mck-msg-right .mck-msg-box {
  white-space: normal !important;
}

#mck-sidebox #mck-message-cell .mck-message-inner .mck-msg-right .mck-msg-box p {
  margin: 0 !important;
}

/* Rich text tags inside bubbles */
#mck-sidebox #mck-message-cell .mck-message-inner .mck-msg-box strong,
#mck-sidebox #mck-message-cell .mck-message-inner .mck-msg-box b {
  font-weight: 700 !important;
}

#mck-sidebox #mck-message-cell .mck-message-inner .mck-msg-box em,
#mck-sidebox #mck-message-cell .mck-message-inner .mck-msg-box i {
  font-style: italic !important;
}

#mck-sidebox #mck-message-cell .mck-message-inner .mck-msg-box u {
  text-decoration: underline !important;
}

#mck-sidebox #mck-message-cell .mck-message-inner .mck-msg-box s,
#mck-sidebox #mck-message-cell .mck-message-inner .mck-msg-box del {
  text-decoration: line-through !important;
}

#mck-sidebox #mck-message-cell .mck-message-inner .mck-msg-box a {
  text-decoration: underline !important;
  text-underline-offset: 2px !important;
}

/* Inline bot images injected by src/image-placeholders.js */
#mck-sidebox #mck-message-cell .mck-message-inner .mck-msg-box .fintepla-inline-image {
  display: block !important;
  max-width: 100% !important;
  height: auto !important;
  border-radius: 8px !important;
  margin: 8px 0 !important;
}

/* Quick reply button groups */
#mck-sidebox #mck-message-cell .mck-message-inner .km-cta-multi-button-container {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 8px !important;
  align-items: flex-start !important;
}

#mck-sidebox #mck-message-cell .mck-message-inner button.km-quick-replies {
  color: var(--fintepla-purple) !important;
  background: #ffffff !important;
  border: 1px solid var(--fintepla-purple) !important;
  border-radius: 8px !important;
  padding: 0.5rem 1rem !important;
  cursor: pointer !important;
  transition: background-color 0.2s ease, color 0.2s ease !important;
  font-family: 'Tisa Sans Pro', sans-serif !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  font-weight: 400 !important;
}

#mck-sidebox #mck-message-cell .mck-message-inner button.km-quick-replies:hover {
  background: rgba(104, 48, 142, 0.08) !important;
}
